// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"223":"27b928b5","718":"4304e210","842":"846fe7cd"}[chunkId] + ".css";
};